/* SASSEAZE: Instagram handle required for booked services. Added Sept 2026. */
(function () {
  if (window.__igRequired) return;
  window.__igRequired = true;

  function clean(v) {
    v = (v || '').trim();
    if (!v) return '';
    v = v.replace(/^https?:\/\/(www\.)?instagram\.com\//i, '').replace(/[\/?#].*$/, '').replace(/\s+/g, '');
    v = v.replace(/^@+/, '');
    return v ? '@' + v : '';
  }

  function findIg(el) {
    var node = el;
    for (var i = 0; node && i < 6; i++) {
      if (node.querySelector) {
        var inp = node.querySelector('.ig-handle-input');
        if (inp) return inp;
      }
      node = node.parentElement;
    }
    return null;
  }

  function showErr(input, on) {
    var wrap = input.closest('.ig-handle-field');
    var err = wrap && wrap.querySelector('.ig-handle-error');
    if (err) err.hidden = !on;
    input.style.borderColor = on ? '#b3261e' : '';
    input.style.borderWidth = on ? '2px' : '';
    if (on) {
      try { input.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
      input.focus();
    }
  }

  function saveNote(handle) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var note = cart.note || '';
        if (note.indexOf(handle) !== -1) return;
        var line = 'Instagram: ' + handle;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: note ? note + '\n' + line : line })
        });
      })
      .catch(function () {});
  }

  function validate(input) {
    var v = clean(input.value);
    if (!v) { showErr(input, true); return ''; }
    input.value = v;
    showErr(input, false);
    return v;
  }

  document.addEventListener('input', function (ev) {
    var t = ev.target;
    if (t && t.classList && t.classList.contains('ig-handle-input') && t.value.trim()) showErr(t, false);
  }, true);

  /* Block add to cart without a handle */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.querySelector) return;
    var input = form.querySelector('.ig-handle-input');
    if (!input) return;
    var v = validate(input);
    if (!v) { ev.preventDefault(); ev.stopImmediatePropagation(); return; }
    saveNote(v);
  }, true);

  /* Block the booking button and add to cart button without a handle */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var btn = t.closest('button, [role="button"], input[type="submit"], a');
    if (!btn) return;
    if (btn.closest('.ig-handle-field')) return;
    var label = (btn.textContent || btn.value || '').trim();
    var isAdd = btn.getAttribute('name') === 'add' || btn.type === 'submit' && btn.closest('form[action*="/cart/add"]');
    var isBook = /book/i.test(label) || /book|appoint/i.test(btn.className || '');
    if (!isAdd && !isBook) return;
    var input = findIg(btn);
    if (!input) return;
    if (!validate(input)) { ev.preventDefault(); ev.stopImmediatePropagation(); }
  }, true);

  /* Checkout guard: any booked item without a handle */
  function needsHandle(item) {
    var p = item.properties || {};
    if (p.Instagram && String(p.Instagram).trim()) return false;
    return !!(p['_bookeasy-booking-id'] || p.Date || p.Time);
  }

  function askHandle() {
    return new Promise(function (resolve) {
      var ov = document.createElement('div');
      ov.setAttribute('role', 'dialog');
      ov.setAttribute('aria-modal', 'true');
      ov.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:16px;';
      ov.innerHTML = '<form style="background:#fff;color:#222;max-width:420px;width:100%;padding:24px;border-radius:12px;font-family:inherit;box-sizing:border-box;">' +
        '<h2 style="margin:0 0 8px;font-size:20px;">One more thing before checkout</h2>' +
        '<p style="margin:0 0 14px;font-size:15px;line-height:1.4;">Please enter your Instagram handle so Starlight can reach you for your session.</p>' +
        '<input name="ig" type="text" placeholder="@yourhandle" autocomplete="off" autocapitalize="off" spellcheck="false" style="width:100%;box-sizing:border-box;padding:12px;font-size:16px;border:1px solid #888;border-radius:6px;">' +
        '<p class="igx-err" hidden style="color:#b3261e;margin:8px 0 0;font-size:14px;">Your Instagram handle is required.</p>' +
        '<div style="display:flex;gap:10px;margin-top:16px;justify-content:flex-end;">' +
        '<button type="button" class="igx-cancel" style="padding:10px 16px;font-size:15px;background:#eee;border:0;border-radius:6px;cursor:pointer;">Cancel</button>' +
        '<button type="submit" style="padding:10px 16px;font-size:15px;background:#5a12b8;color:#fff;border:0;border-radius:6px;cursor:pointer;">Continue to checkout</button>' +
        '</div></form>';
      document.body.appendChild(ov);
      var f = ov.querySelector('form');
      var inp = ov.querySelector('input');
      setTimeout(function () { inp.focus(); }, 50);
      ov.querySelector('.igx-cancel').addEventListener('click', function () { ov.remove(); resolve(''); });
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var v = clean(inp.value);
        if (!v) { ov.querySelector('.igx-err').hidden = false; inp.focus(); return; }
        ov.remove();
        resolve(v);
      });
    });
  }

  function checkCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var missing = (cart.items || []).filter(needsHandle);
        if (!missing.length) return true;
        return askHandle().then(function (handle) {
          if (!handle) return false;
          var chain = Promise.resolve();
          missing.forEach(function (item) {
            chain = chain.then(function () {
              var props = Object.assign({}, item.properties || {}, { Instagram: handle });
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
              });
            });
          });
          return chain.then(function () { return saveNote(handle); }).then(function () { return true; });
        });
      })
      .catch(function () { return true; });
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var el = t.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkout?"], a[href*="/checkout"]');
    if (!el || el.closest('.shopify-payment-button')) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    checkCart().then(function (ok) {
      if (ok) window.location.href = '/checkout';
    });
  }, true);
/* Prefill the booking app's own Instagram question from the handle already entered */
  document.addEventListener('focusin', function (ev) {
    var t = ev.target;
    if (!t || t.tagName !== 'INPUT' || t.classList.contains('ig-handle-input') || t.value) return;
    var box = t.parentElement, txt = '';
    for (var i = 0; box && i < 3; i++) { txt = box.textContent || ''; if (/instagram/i.test(txt)) break; box = box.parentElement; }
    if (!/instagram/i.test(txt)) return;
    var src = document.querySelector('.ig-handle-input');
    var v = src && clean(src.value);
    if (!v) return;
    try {
      var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
      setter.call(t, v);
      t.dispatchEvent(new Event('input', { bubbles: true }));
      t.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
  }, true);
})();

(function () {
  function sync() {
    document.querySelectorAll('.custom-consult-cta').forEach(function (cta) {
      var ids = (cta.getAttribute('data-custom-ids') || '').split(',').filter(Boolean);
      var form = cta.closest('form') || document;
      var idInput = form.querySelector('input[name="id"]');
      var on = idInput && ids.indexOf(String(idInput.value)) !== -1;
      cta.hidden = !on;
      var btns = form.querySelector('.product-form__buttons');
      if (btns) btns.style.display = on ? 'none' : '';
    });
  }
  document.addEventListener('change', function () { setTimeout(sync, 60); setTimeout(sync, 400); }, true);
  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('load', sync);
  document.addEventListener('submit', function (ev) {
    var f = ev.target; if (!f || !f.querySelector) return;
    var cta = f.querySelector('.custom-consult-cta');
    if (cta && !cta.hidden) { ev.preventDefault(); ev.stopImmediatePropagation(); }
  }, true);
})();
